import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import moment from 'moment';
import { TechnicianService } from '../../../../../../services/technician.service';
import { UserEditComponent } from '../../../../../modals/user-edit/user-edit.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-technicians-schedule',
  templateUrl: './technicians-schedule.component.html',
  styleUrls: ['./technicians-schedule.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TechniciansScheduleComponent implements OnInit {
  @Input() technician;
  @Input() technicianID;
  @Input() fromDate;
  @Input() toDate;
  @Input() techniciansAllowed;
  @Input() allocatedTechnicians;
  @Output() updateDate = new EventEmitter();
  @Output() getUsers = new EventEmitter();

  public defaultWorkHours: any = {};
  public configuredWorkHours: any = [];
  public defaultDate = new Date(1970, 1, 1, 0, 0, 0);
  public selectedDates = [];
  public dates = [];
  public selectedDate: any = null;
  public loadingCalendar = false;
  public defaultHoursSet = false;

  @ViewChild('avalabilityCalendar') avalabilityCalendar;

  constructor(
    private technicianService: TechnicianService,
    private modalService: NgbModal,
    private messageService: MessageService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {}

  ngOnChanges(changes) {
    this.selectedDate = null;
    this.getAvailabilitySettings();
  }

  getAvailabilitySettings() {
    this.loadingCalendar = true;
    this.technicianService
      .getTechnicianiAvailabilitySettings(
        this.technicianID,
        moment(this.fromDate).format('YYYY-MM-DD'),
        moment(this.toDate).format('YYYY-MM-DD'),
      )
      .subscribe(
        (result) => {
          this.defaultWorkHours = {
            ...result.defaultWorkHours,
            mondayStart: result.defaultWorkHours.mondayStart || '00:00',
            mondayEnd: result.defaultWorkHours.mondayEnd || '00:00',
            tuesdayStart: result.defaultWorkHours.tuesdayStart || '00:00',
            tuesdayEnd: result.defaultWorkHours.tuesdayEnd || '00:00',
            wednesdayStart: result.defaultWorkHours.wednesdayStart || '00:00',
            wednesdayEnd: result.defaultWorkHours.wednesdayEnd || '00:00',
            thursdayStart: result.defaultWorkHours.thursdayStart || '00:00',
            thursdayEnd: result.defaultWorkHours.thursdayEnd || '00:00',
            fridayStart: result.defaultWorkHours.fridayStart || '00:00',
            fridayEnd: result.defaultWorkHours.fridayEnd || '00:00',
            saturdayStart: result.defaultWorkHours.saturdayStart || '00:00',
            saturdayEnd: result.defaultWorkHours.saturdayEnd || '00:00',
            sundayStart: result.defaultWorkHours.sundayStart || '00:00',
            sundayEnd: result.defaultWorkHours.sundayEnd || '00:00',
          };
          var configuredWorkHours = result.configuredWorkHours;
          this.selectedDates = configuredWorkHours.map((x) => {
            return new Date(x.date);
          });

          this.checkIfDefaultHoursSet();

          for (
            var date = moment(this.fromDate);
            moment(date).unix() <= moment(this.toDate).unix();
            date = moment(date).add(1, 'days')
          ) {
            var found = configuredWorkHours
              .filter((x) => {
                return (
                  moment(x.date).format('YYYY-MM-DD') ===
                  date.format('YYYY-MM-DD')
                );
              })
              .pop();
            if (!found) {
              if (moment(date).weekday() === 0) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.sundayStart,
                  endTime: this.defaultWorkHours.sundayEnd,
                  onlineHours: this.defaultWorkHours.sundayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.sundayStart != '00:00' ||
                    this.defaultWorkHours.sundayEnd !== '00:00',
                });
              } else if (moment(date).weekday() === 1) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.mondayStart,
                  endTime: this.defaultWorkHours.mondayEnd,
                  onlineHours: this.defaultWorkHours.mondayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.mondayStart != '00:00' ||
                    this.defaultWorkHours.mondayEnd !== '00:00',
                });
              } else if (moment(date).weekday() === 2) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.tuesdayStart,
                  endTime: this.defaultWorkHours.tuesdayEnd,
                  onlineHours: this.defaultWorkHours.tuesdayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.tuesdayStart != '00:00' ||
                    this.defaultWorkHours.tuesdayEnd !== '00:00',
                });
              } else if (moment(date).weekday() === 3) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.wednesdayStart,
                  endTime: this.defaultWorkHours.wednesdayEnd,
                  onlineHours: this.defaultWorkHours.wednesdayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.wednesdayStart != '00:00' ||
                    this.defaultWorkHours.wednesdayEnd !== '00:00',
                });
              } else if (moment(date).weekday() === 4) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.thursdayStart,
                  endTime: this.defaultWorkHours.thursdayEnd,
                  onlineHours: this.defaultWorkHours.thursdayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.thursdayStart != '00:00' ||
                    this.defaultWorkHours.thursdayEnd !== '00:00',
                });
              } else if (moment(date).weekday() === 5) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.fridayStart,
                  endTime: this.defaultWorkHours.fridayEnd,
                  onlineHours: this.defaultWorkHours.fridayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.fridayStart != '00:00' ||
                    this.defaultWorkHours.fridayEnd !== '00:00',
                });
              } else if (moment(date).weekday() === 6) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.saturdayStart,
                  endTime: this.defaultWorkHours.saturdayEnd,
                  onlineHours: this.defaultWorkHours.saturdayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.saturdayStart != '00:00' ||
                    this.defaultWorkHours.saturdayEnd !== '00:00',
                });
              }
            }
          }
          this.configuredWorkHours = configuredWorkHours;
          this.loadingCalendar = false;
        },
        (err) => {
          this.loadingCalendar = false;
        },
      );
  }

  checkIfDefaultHoursSet() {
    if (
      this.defaultWorkHours.mondayStart != '00:00' ||
      this.defaultWorkHours.mondayEnd != '00:00' ||
      this.defaultWorkHours.tuesdayStart != '00:00' ||
      this.defaultWorkHours.tuesdayEnd != '00:00' ||
      this.defaultWorkHours.wednesdayStart != '00:00' ||
      this.defaultWorkHours.wednesdayEnd != '00:00' ||
      this.defaultWorkHours.thursdayStart != '00:00' ||
      this.defaultWorkHours.thursdayEnd != '00:00' ||
      this.defaultWorkHours.fridayStart != '00:00' ||
      this.defaultWorkHours.fridayEnd != '00:00' ||
      this.defaultWorkHours.saturdayStart != '00:00' ||
      this.defaultWorkHours.saturdayEnd != '00:00' ||
      this.defaultWorkHours.sundayStart != '00:00' ||
      this.defaultWorkHours.sundayEnd != '00:00'
    ) {
      this.defaultHoursSet = true;
    }
  }

  formatTime(value) {
    return value === null || value === undefined
      ? '00:00'
      : moment((value.length === 5 ? '1970-01-01T' : '') + value).format(
          'HH:mm',
        );
  }

  getMaxHours(start, end) {
    if (
      start === null ||
      start === undefined ||
      end === null ||
      end === undefined ||
      start === '00:00' ||
      end === '00:00'
    )
      return 0;
    if (start.toString().length > 5) {
      start = moment(start).format('HH:mm');
    }
    if (end.toString().length > 5) {
      end = moment(end).format('HH:mm');
    }
    return moment('1970-01-01T' + end).diff(
      moment('1970-01-01T' + start),
      'hours',
    );
  }

  updateDateSelected(selectedDate) {
    if (selectedDate) {
      var data = {
        id: selectedDate.id,
        date: moment(selectedDate.date).toDate(),
        startTime: moment('1970-01-01T' + selectedDate.startTime).toDate(),
        endTime: moment('1970-01-01T' + selectedDate.endTime).toDate(),
        onlineHours: selectedDate.onlineHours,
        isWorking: selectedDate.working,
      };
      this.updateTechnicianActualHours({
        ...data,
        date: moment(data.date).format('YYYY-MM-DD'),
        startTime: moment(data.startTime).format('HH:mm:ss'),
        endTime: moment(data.endTime).format('HH:mm:ss'),
      });

      if (!selectedDate.working) {
        this.selectedDate = null;
      } else {
        this.selectedDate = data;
        //this.dayHoursOverview.show(selectedDate,this.avalabilityCalendar);
      }
    }
  }

  updateTechnicianActualHours(data, reload = false) {
    this.configuredWorkHours = this.configuredWorkHours.map((x) => {
      if (
        moment(x.date).format('YYYY-MM-DD') ===
        moment(data.date).format('YYYY-MM-DD')
      ) {
        return data;
      }
      return x;
    });
    this.technicianService
      .updateTechnicianActualHours(this.technicianID, data)
      .subscribe((res) => {
        this.configuredWorkHours = this.configuredWorkHours.map((x) => {
          if (
            moment(x.date).format('YYYY-MM-DD') ===
            moment(data.date).format('YYYY-MM-DD')
          ) {
            return res;
          }
          return x;
        });

        if (reload) {
          this.getAvailabilitySettings();
          this.messageService.add({
            detail: this.translate.instant(
              'bikeshop.users.working_hours_updated',
            ),
          });
        }
      });
  }

  actualUpdated() {
    if (this.selectedDate.endTime <= this.selectedDate.startTime) {
      this.selectedDate.endTime = this.selectedDate.startTime;
    }
    this.updateTechnicianActualHours(
      {
        ...this.selectedDate,
        date: moment(this.selectedDate.date).format('YYYY-MM-DD'),
        startTime: moment(this.selectedDate.startTime).format('HH:mm:ss'),
        endTime: moment(this.selectedDate.endTime).format('HH:mm:ss'),
      },
      true,
    );
  }

  getMonthData(event) {
    this.fromDate = event.fromDate;
    this.toDate = event.toDate;
    this.getAvailabilitySettings();

    this.updateDate.emit({ fromDate: this.fromDate, toDate: this.toDate });
  }

  openTechnicianAvailability() {
    const modalRef = this.modalService.open(UserEditComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.user = this.technician;
    modalRef.componentInstance.techniciansAllowed = this.techniciansAllowed;
    modalRef.componentInstance.allocatedTechnicians = this.allocatedTechnicians;
    modalRef.componentInstance.defaultTab = 'AVAILABILITY';
    modalRef.result.then(
      (result) => {
        this.getAvailabilitySettings();
        this.getUsers.emit();
      },
      (onrejected) => {
        this.getAvailabilitySettings();
        this.getUsers.emit();
      },
    );
  }
}
